<template>
    <div class="projectTypes">
        <router-link :to="{name: 'calculation.constructionSelect', params:{projectSlug: project.slug}}"
                     :key="project.slug" class="projectTypes__item"
                     v-for="project in projects">
                <span class="projectTypes__itemImage">
                    <img :src="'/wp-content/themes/rigips/images/icon/'+project.icon" :alt="project.name">
                </span>
            <span class="projectTypes__itemName">{{project.name}}</span>
        </router-link>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'CalculationProjectList',
        computed: {
            ...mapGetters('calculation', ['projects']),
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/project/ProjectList.vue